import axios from '@/api/axios'

const changeFeedbackStatus = (feedbackId, date) => {
  return axios.put(`/appeals/${feedbackId}/status`, date)
}

const getFeedbackList = (params) => {
  return axios.get('/appeals/listForAdmin', {params})
}

const getFeedbackInfo = (id) => {
  return axios.get(`/appeals/${id}`)
}

export default {
  getFeedbackList,
  getFeedbackInfo,
  changeFeedbackStatus,
}
